import ProductOptionCategoryRequest from '@/communication/ProductOptionCategoryRequest';
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import _ from 'lodash';
import { ProductOptionCategoryObject } from '@/types/joostconnector';
import { reactive } from 'vue';

export function useExtraOptions() {
  const extraOptionsStore = useExtraOptionsStore();
  const request = reactive(new ProductOptionCategoryRequest());

  async function requestCategories(
    sku: string,
    useForConfigurableCollection: boolean = false
  ): Promise<void> {
    // Cancel previous request
    request.cancel('Initiating new request');

    // Get response from GA
    const response = await request.setProductSku(sku).getResponse();

    // Set product option categories
    let productOptionCategories = response.data[0];

    // Filter out the categories which aren't used for configurable collection
    if (useForConfigurableCollection) {
      productOptionCategories = _.filter(
        productOptionCategories,
        (productOptionCategory: ProductOptionCategoryObject) =>
          productOptionCategory.useForConfigurableCollection
      );
    }

    // Set categories in store
    extraOptionsStore.productOptionsCategories = productOptionCategories;
  }

  return {
    request,
    requestCategories,
  };
}
